import { FC } from 'react';
import useRouterBack from '@/hooks/useRouterBack';
import useBookmarkToggle from '@/hooks/useBookmark';
import useDrawer from '@/hooks/useDrawer';
import NavbarMobile from '@/components/houses/housesMobile/navbarMobile/NavbarMobile';
import TopSliderMobile from '@/components/houses/housesMobile/topSlider/TopSlider';
import { ProductItemTypes } from '../../_types/productItem.types';
type TopNavbarProps = {
  productState: ProductItemTypes;
};
const TopNavbar: FC<TopNavbarProps> = ({
  productState
}) => {
  const {
    handleBack
  } = useRouterBack();
  const {
    drawerOpen
  } = useDrawer();
  const {
    isBookmarked,
    toggleBookmark
  } = useBookmarkToggle(productState?.id);
  return <>
      <TopSliderMobile images={productState?.pictures?.records} isBookmarked={isBookmarked} handleFavorite={toggleBookmark} handleBack={handleBack} data-sentry-element="TopSliderMobile" data-sentry-source-file="TopNavbar.tsx" />
      <NavbarMobile productState={productState} isBookmarked={isBookmarked} handleFavorite={toggleBookmark} handleOpenShare={drawerOpen} handleBack={handleBack} data-sentry-element="NavbarMobile" data-sentry-source-file="TopNavbar.tsx" />
    </>;
};
export default TopNavbar;